module.exports = __webpack_public_path__ + "img/incision-showcase-black.f863b565.jpg";